/**
 * Lower-cases, strips accents and collapses everything that is not a letter or digit to single
 * spaces, so "Grüner  Veltliner", "gruner-veltliner" and "GRUNER VELTLINER" meet in one key. The
 * lexicons match what a person typed, so they must forgive how it was typed.
 */
export function foldName(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}
